'use client';

import { useEffect } from 'react';
import posthog from 'posthog-js';

/**
 * PostHog analytics provider
 * Initializes PostHog for web analytics tracking
 * Project: https://us.posthog.com/project/330187
 *
 * Uses environment variables:
 * - NEXT_PUBLIC_POSTHOG_KEY: Your PostHog project API key
 * - NEXT_PUBLIC_POSTHOG_HOST: PostHog host (https://us.i.posthog.com)
 */
export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Defer analytics initialization until the browser is idle
    const init = () => {
      const apiKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
      const apiHost = process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com';

      if (!apiKey) {
        console.warn('PostHog: NEXT_PUBLIC_POSTHOG_KEY is not set');
        return;
      }

      posthog.init(apiKey, {
        api_host: apiHost,
        defaults: '2026-01-30',
        capture_pageview: true,
        capture_pageleave: true,
        loaded: (posthog) => {
          if (process.env.NODE_ENV === 'development') {
            posthog.debug();
          }
        },
      });
    };

    if (typeof window !== 'undefined') {
      if ('requestIdleCallback' in window) {
        (window as any).requestIdleCallback(init, { timeout: 5000 });
      } else {
        setTimeout(init, 3000);
      }
    }
  }, []);

  return <>{children}</>;
}

export default PostHogProvider;
